import React from 'react'

type Props = {
  label: string;
}

export const Tag: React.FC<Props> = ({ label }: Props) => (
  <span className="tag">{label}</span>
)